<div class="coming-soon-page" [style.grid-column]="'2 / span 10'">
  <app-coming-soon-status
    title="No Integration Found"
    message="We're working on integrations. This feature will be available shortly."
    icon="@tui.plug"
  />
</div>
